import 'twin.macro';
import 'styled-components/macro';
import * as React from 'react';

export interface PlaceholderProps {
  title?: string;
  description?: string;
  illustration?: string;
  className?: string;
  buttons?: React.ReactNode;
}

export const Placeholder = ({ title, description, illustration, buttons, className }: PlaceholderProps) => {
  return (
    <div className={className} tw="flex flex-col bg-white items-center rounded-lg p-8">
      {illustration && title && <img tw="w-1/2 max-h-60 mb-3" src={illustration} alt="illustration" />}
      {illustration && !title && <img tw="w-full" src={illustration} alt="illustration" />}
      {title && <h2 tw="display-4 mb-1">{title}</h2>}
      {description && <p tw="text-center max-w-prose">{description}</p>}
      {buttons && <div tw="flex flex-wrap gap-x-1 gap-y-2 justify-center mt-3 text-center">{buttons}</div>}
    </div>
  );
};
